module.exports = __webpack_public_path__ + "img/Campfire.839d2281.png";